/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringProviderConfigResponseOutputEndpointMax = 2000;

export const monitoringProviderConfigResponseOutputHeadersMax = 5;

export const monitoringProviderConfigResponseOutputParametersMax = 40;

export const MonitoringProviderConfigResponseOutput = zod.object({
  provider: zod.enum(['checkly', 'datadog', 'grafana', 'prtg']),
  profileVersion: zod.string(),
  verification: zod.literal('unverified'),
  limitations: zod.string(),
  endpoint: zod.url().max(monitoringProviderConfigResponseOutputEndpointMax),
  format: zod.enum(['json', 'form']),
  headers: zod
    .array(
      zod.object({
        name: zod.string(),
        value: zod.string(),
      }),
    )
    .max(monitoringProviderConfigResponseOutputHeadersMax),
  template: zod.string(),
  parameters: zod
    .array(
      zod.object({
        name: zod.string(),
        meaning: zod.string(),
      }),
    )
    .max(monitoringProviderConfigResponseOutputParametersMax),
});

export type MonitoringProviderConfigResponseOutput = zod.input<
  typeof MonitoringProviderConfigResponseOutput
>;
export type MonitoringProviderConfigResponseOutputOutput = zod.output<
  typeof MonitoringProviderConfigResponseOutput
>;
